import { Marker } from 'react-map-gl/mapbox'
import { DriverStatusIcon } from '../../DriverStatusIcon'
import 'mapbox-gl/dist/mapbox-gl.css'
import '../styles.css'
import type { PopoverInfo } from '../types'
import { checkIsDriverOffline, getActionColor } from '../../../util'
import { showLivePulse } from '../util'

type DriverMapMarkerProps = {
  driverInfo: PopoverInfo
  driverId: string
  handleDriverSelect: (driverId: string) => void
  setPopoverInfo: (info: PopoverInfo | null) => void
}

export function DriverMapMarker({ driverInfo, driverId, handleDriverSelect, setPopoverInfo }: DriverMapMarkerProps) {
  if (driverInfo.popoverType !== 'driver' || driverInfo.lat === null || driverInfo.lon === null) {
    return null // Don't render marker if lat/lon are not available
  }
  const color = getActionColor(driverInfo.action)
  const showPulse = showLivePulse(driverInfo.lastHeartbeat, driverInfo.complete)
  const isDisabled = !driverInfo.lastHeartbeat || !driverInfo.action

  return (
    <Marker longitude={driverInfo.lon} latitude={driverInfo.lat}>
      <div
        className='driver-map-marker'
        onMouseEnter={() => setPopoverInfo(driverInfo)}
        onMouseLeave={() => setPopoverInfo(null)}
        onClick={() => {
          if (isDisabled) return
          setPopoverInfo(null)
          return handleDriverSelect(driverId)
        }}
        onKeyUp={(e) => {
          if ((e.key === 'Enter' || e.key === ' ') && !isDisabled) {
            setPopoverInfo(driverInfo)
          }
        }}
        tabIndex={0}
        role='button'
      >
        <div className={showPulse ? 'pulse-ring' : ''} style={{ backgroundColor: color }} />
        <div className='driver-status-icon-overlay'>
          <DriverStatusIcon action={driverInfo.action} isCompleted={driverInfo.complete} />
        </div>
      </div>
    </Marker>
  )
}
